export default "__VITE_ASSET__DoN8W3DX__"